const routes = [
    {
        path: "/semester/dates",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "semesterdate_index"
        }
    }
];

export default routes;
